interface truncateProps {
  textValue: string;
  maxTextLength?: number;
}

export const truncateText = ({
  textValue,
  maxTextLength,
                             }: truncateProps): string => {
  const maxLength = maxTextLength ?? 45;

  if (textValue.length > maxLength) {
    textValue = textValue.slice(0, maxLength);

    if (textValue.includes('...')) {
      textValue = textValue.replace(/\.{3,}/g, '');
    }

    textValue = textValue.trim() + '...';
  }

  return textValue;
};
